"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOrderRefundMade = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconOrderRefundMade = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#464650", d: "M18.5,18 C20.43,18 22,16.43 22,14.5 C22,12.57 20.43,11 18.5,11 C16.57,11 15,12.57 15,14.5 C15,16.43 16.57,18 18.5,18 Z M2,16.453 C2,16.755 2.233,17 2.52,17 L14.762,17 C14.281,16.284 14,15.425 14,14.5 C14,13.079 14.675,11.825 15.706,11 L2,11 L2,16.453 Z M2.52,7 C2.233,7 2,7.245 2,7.547 L2,9 L18,9 L18,7.547 C18,7.245 17.767,7 17.48,7 L2.52,7 Z M19,10.051 C21.244,10.303 23,12.189 23,14.5 C23,16.981 20.981,19 18.5,19 C17.439,19 16.477,18.616 15.706,18 L2.52,18 C1.682,18 1,17.306 1,16.453 L1,7.547 C1,6.694 1.682,6 2.52,6 L17.48,6 C18.318,6 19,6.694 19,7.547 L19,10.051 Z M3,14 L3,13 L11,13 L11,14 L3,14 Z M3,16 L3,15 L9,15 L9,16 L3,16 Z" }),
            React.createElement("path", { fill: !!theme ? (theme.name !== 'privalia' ? theme.colors.main.base : theme.colors.red.s75) : '#EC008C', d: "M20.4897,14.7529 C20.4197,14.2219 19.9577,13.8199 19.4157,13.8199 L17.2077,13.8199 L17.6287,13.3719 C17.7077,13.2869 17.7077,13.1489 17.6287,13.0639 C17.5487,12.9789 17.4197,12.9789 17.3397,13.0639 L16.5597,13.8969 C16.4797,13.9819 16.4797,14.1189 16.5597,14.2049 L17.3397,15.0369 C17.3797,15.0789 17.4317,15.1009 17.4837,15.1009 C17.5357,15.1009 17.5887,15.0789 17.6287,15.0369 C17.7077,14.9509 17.7077,14.8139 17.6287,14.7289 L17.1857,14.2569 L19.4157,14.2569 C19.7507,14.2569 20.0447,14.5009 20.0857,14.8139 C20.1107,15.0079 20.0597,15.1929 19.9417,15.3389 C19.8247,15.4819 19.6567,15.5649 19.4797,15.5649 L19.0297,15.5649 C18.9167,15.5649 18.8247,15.6609 18.8247,15.7819 C18.8247,15.9019 18.9167,15.9999 19.0297,15.9999 L19.4797,15.9999 C19.7757,15.9999 20.0557,15.8629 20.2497,15.6249 C20.4437,15.3869 20.5317,15.0679 20.4897,14.7529" }))));
};
exports.IconOrderRefundMade = IconOrderRefundMade;
exports.IconOrderRefundMade.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconOrderRefundMade;
